// created by wangshuyi on 2022/9/1

'use strict';
import router from '@/router';
import { ajax } from "dolphin-framework-vue";

const state = {
  cookieName: process.env.VUE_APP_COOKIE_NAME,
  loading: false,
  menuList: [],
  menuActive: {},
  pageMap: {},
  hasMenuLoaded: false,

  prompt: {
    title: '请输入',
    desc: null,
    icon: null,
    visible: false,
    type: 'input',
    onOk: null,
    onCancel: null,
    value: null,
  }
};

const mutations = {
  init(state) {
    const sessionStorageStr = sessionStorage.getItem(state.cookieName);
    if (sessionStorageStr) {
      const sessionInfo = JSON.parse(sessionStorageStr);
      for (const module in sessionInfo) {
        if (/lang/.test(module)) {
          continue;
        }
        for (const field in sessionInfo[module]) {
          if (/loading|prompt/.test(field)) {
            continue;
          }

          this.state[module][field] = sessionInfo[module][field];
        }
      }
    }
  },
  session(state) {
    sessionStorage.setItem(state.cookieName, JSON.stringify(this.state));
  },
  setLoading(state, flag) {
    state.loading = flag;
  },

  saveMenu(state, { menuList, pageMap }) {
    // console.log('saveMenu === ', menuList, pageMap)
    state.menuList = menuList;
    state.pageMap = pageMap;
    state.hasMenuLoaded = true;
    this.commit('app/session');
  },
  setActiveMenu(state, _path) {
    const path = _path.replace('/', '');
    // console.log('setActiveMenu ----------', path, state.pageMap[path]);
    state.menuActive = state.pageMap[path];
    this.commit('app/session');
  },
};

const actions = {
  queryMenu() {
    return ajax({ url: '/portal/queryMenu', }).then(({ rows }) => {
      const indexChildren = [];
      const pageMap = {};
      rows.forEach(menu => {
        if (menu.type === 'page') {
          const path = menu.link || menu._id;
          pageMap[path] = { path: path, name: menu.name };
          let componentUrl = menu.vueLink || '/previewPage'
          indexChildren.push({
            path: path,
            name: menu.name,
            component: () => import(`@/views${componentUrl}`),
          });
        } else {
          menu.children.forEach(child => {
            if (child.type === 'page') {
              const path = child.link || child._id;
              pageMap[path] = { path: path, name: child.name, parentId: menu._id };
              let componentUrl = child.vueLink || '/previewPage'
              indexChildren.push({
                path: path,
                name: child.name,
                component: () => import(`@/views${componentUrl}`),
              });
            }
          });
        }
      });
      router.addRoute({
        path: '/',
        name: 'index',
        component: () => import(`@/views/index`),
        children: indexChildren
      });
      this.commit('app/saveMenu', { menuList: rows, pageMap });
      return true;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
